import DocumentsPage from './Page';
export default DocumentsPage;
